var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.15,
    stroke: "#1A5C2C",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.912L13.488 6L9.312 10.176L8.376 9.228L10.692 6.912L9.78 6L5.604 10.176L3.912 8.484L3 9.396L5.604 12L7.464 10.14L9.312 12L14.4 6.912Z",
    fill: "#1A5C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.6818b9c3f5a7c777457b5e5fa4ab5205.svg";
export { ForwardRef as ReactComponent };